var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThyroidHealth = function SvgThyroidHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.32 4c-.629 0-1.066-.401-1.166-1.028a.22.22 0 0 0-.21-.19H8.908a.197.197 0 0 0-.178.283c.404.835.939 1.837 1.24 3.12l.192.989c.087.375.577.811 2.157.811s2.075-.46 2.157-.811l.192-.988c.302-1.284.836-2.286 1.24-3.12a.197.197 0 0 0-.178-.283h-2.04a.22.22 0 0 0-.21.189C13.38 3.595 12.946 4 12.32 4M14.468 7.226v2.288m-4.315-2.288v2.288M14.468 17.812v.814c-.082.352-.578.811-2.157.811s-2.07-.436-2.158-.811v-.814"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.468 18.755v2.089c-.082.351-.578.811-2.157.811s-2.07-.436-2.158-.811v-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 5.76c-1.538 0-2.821 1.29-3.14 2.66-.197.853-.977 1.784-3.04 1.784s-2.843-.932-3.04-1.783C8.96 7.05 7.678 5.76 6.139 5.76c-1.537 0-2.797 1.158-2.797 2.56 0 5.652 2.798 3.875 2.798 8.264 0 .886 1.065 1.656 2.123 1.656.49 0 .995-.161 1.297-.436.818-.745 1.789-1.118 2.76-1.123.97.005 1.94.378 2.758 1.123.303.275.808.436 1.297.436 1.058 0 2.124-.77 2.124-1.656 0-4.389 2.797-2.612 2.797-8.265 0-1.4-1.26-2.56-2.797-2.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.411 9.289c0 .508-.573 1.27-1.18 1.27M14.326 14.627c0-.508.573-1.27 1.18-1.27M6.295 9.29c0 .507.573 1.27 1.18 1.27M10.313 14.627c0-.508-.573-1.27-1.18-1.27"
  })))));
};
export default SvgThyroidHealth;